import React from 'react';
import PropTypes from 'prop-types';
import { Field, propTypes, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { translate, userLogin } from 'ra-core';
import { showNotification } from 'react-admin';
import { HOST, API } from '../../configs/index'

const styles = () => ({
  form: {
    padding: '0 1em 1em 1em',
  },
  input: {
    marginTop: '1em',
  },
  button: {
    width: '100%',
  },
});

// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({
  meta: { touched, error } = {}, // eslint-disable-line react/prop-types
  input: { ...inputProps }, // eslint-disable-line react/prop-types
  ...props
}) => (
    <TextField
      error={!!(touched && error)}
      helperText={touched && error}
      {...inputProps}
      {...props}
      fullWidth
    />
  );

class RegisterForm extends React.Component {
  state = {
    loadding: false
  }
  register = async (props) => {
    const { showNotification, onSuccess } = this.props
    await this.setState({ loadding: true })
    const body = { ...props, idp: 'local', username: props.email, role: '5b1c05b4e65e1838250ffc38' }
    const request = new Request(`${HOST}/auth/local/register`, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    fetch(request)
      .then(async (response) => {
        return response.json();
      })
      .then(async ({ statusCode, error, message }) => {
        if ((statusCode < 200 || statusCode >= 300) || error) {
          await this.setState({ loadding: false })
          showNotification(message || error, 'warning');
        } else {
          await this.setState({ loadding: false }, onSuccess)
          showNotification('สมัครสมาชิกสำเร็จ');
        }
      });
  }
  render() {
    const { classes, isLoading, handleSubmit, translate } = this.props
    const { loadding } = this.state
    return (
      <form onSubmit={handleSubmit(this.register)}>
        <div className={classes.form}>
          <div className={classes.input}>
            <Field
              autoFocus
              id="email"
              name="email"
              component={renderInput}
              label={translate('ra.auth.username')}
              disabled={loadding}
            />
          </div>
          <div className={classes.input}>
            <Field
              id="password"
              name="password"
              component={renderInput}
              label={translate('ra.auth.password')}
              type="password"
              disabled={loadding}
            />
          </div>
          <div className={classes.input}>
            <Field
              id="firstname"
              name="firstname"
              component={renderInput}
              label="ชื่อ"
              disabled={loadding}
            />
          </div>
          <div className={classes.input}>
            <Field
              id="lastname"
              name="lastname"
              component={renderInput}
              label="นามสกุล"
              disabled={loadding}
            />
          </div>
          <div className={classes.input}>
            <Field
              id="mobile"
              name="mobile"
              component={renderInput}
              label="เบอร์มือถือ"
              disabled={loadding}
            />
          </div>
        </div>
        <CardActions>
          <Button
            variant="raised"
            type="submit"
            color="primary"
            disabled={loadding}
            className={classes.button}
          >
            {loadding && <CircularProgress size={25} thickness={2} />}
            สมัครใช้งาน
      </Button>
        </CardActions>
      </form>

    );
  }
}


RegisterForm.propTypes = {
  ...propTypes,
  classes: PropTypes.object,
  redirectTo: PropTypes.string,
  showNotification: PropTypes.func,
};

const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

const enhance = compose(
  withStyles(styles),
  translate,
  connect(mapStateToProps, { showNotification }),
  reduxForm({
    form: 'signUp',
    validate: (values, props) => {
      const errors = {};
      const { translate } = props;
      if (!values.email || !(values.email && validateEmail(values.email)))
        errors.email = "อีเมลไม่ถูกต้อง";
      if (!values.password || (values.password && values.password.length < 8))
        errors.password = "รหัสผ่านต้องมีอัขระอย่างน้อย 8 ตัว";
      return errors;
    },
  })
);

const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export default enhance(RegisterForm);



// WEBPACK FOOTER //
// ./src/components/auth/RegisterForm.js